import { Marker, Popup } from 'react-leaflet';

import type { PlaceLocationRecord } from '@navio/nsdk';
import { getNoddiLeafletIcon } from './markers/getNoddiLeafletIcon';

type Props = {
  location: PlaceLocationRecord | null;
};

const formatPlaceSearchAddressLabel = (location: PlaceLocationRecord): string => {
  if (location.addressInfo) {
    return `${location.displayName}, ${location.addressInfo.zipCode} ${location.addressInfo.city}`;
  }

  return location.displayName;
};

export const LeafletSearchMarker = ({ location }: Props) => {
  if (!location?.addressInfo) {
    return null;
  }

  return (
    <Marker icon={getNoddiLeafletIcon({ redMarker: true })} position={[location.latitude, location.longitude]}>
      <Popup>{formatPlaceSearchAddressLabel(location)}</Popup>
    </Marker>
  );
};
